import AListItem from './index.vue';

AListItem.install = app => {
  app.component(AListItem.name, AListItem);
};

export default AListItem;
